import { FormArray, FormControl, FormGroup } from '@angular/forms';

const IP_PATTERN = /^([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})/;

const shouldValidateIpForm = ipExclusionEnabled => ipExclusionEnabled.value;

const validateIpForm = (blockedIps: FormArray) => {
  blockedIps.controls.forEach(ipInput => {
    if (!ipInput.value) {
      ipInput.setErrors({ required: true });
    } else if (!IP_PATTERN.test(ipInput.value)) {
      ipInput.setErrors({ pattern: true });
    }
  });
};

const clearIpFormValidation = (blockedIps: FormArray) => {
  blockedIps.controls.forEach(ipInput => {
    ipInput.setErrors(null);
  });
};

export const GlobalSettingsFormValidator = (group: FormGroup) => {
  const ipExclusionEnabled = group.controls['ipExclusionEnabled'] as FormControl;
  const blockedIps = group.controls['blockedIps'] as FormArray;

  const isIpFormCreated = blockedIps && ipExclusionEnabled;

  if (!isIpFormCreated) {
    return null;
  }

  if (shouldValidateIpForm(ipExclusionEnabled)) {
    validateIpForm(blockedIps);
  } else {
    clearIpFormValidation(blockedIps);
  }
};
